import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "" }

import {computed, inject} from "vue";

import ItemV2VariantsList from "@/components/itemV2/itemV2VariantsList.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2Variants',
  props: [
  "itemIdx",
  "item",
  "sessionId"
],
  emits: ["patch"],
  setup(__props) {



const props = __props;
const loadItemVariants = inject<any>("loadItemVariants");

const variantsList = computed(() => {
  let listOfVariants: {
    idx: string;
    group: string;
    order: number,
    conf_group_idx: string;
    conf_groups_title: object,
    conf_groups: object;
    title: string;
  }[] = [];

  if (props.item && props.item.variants) {
    for (let variantIdx in props.item.variants) {
      const variant = props.item.variants[variantIdx];
      if (!variant) continue;

      if (variant.idx.indexOf("stone_type") !== -1) {
        loadItemVariants(props.itemIdx, variant.idx);
      }


      if (variant.prio === -1) {
        if (
            variant.conf_groups && Object.keys(variant.conf_groups).length !== 0
        ) {
          for (let conf_group_idx in variant.conf_groups) {
            listOfVariants.push({
              idx: variant.idx,
              group: variant.group?.title || "",
              order: variant.order,
              conf_group_idx: conf_group_idx,
              conf_groups: variant.conf_groups,
              conf_groups_title: variant.conf_groups_title,
              title: variant.title,
            });
          }
        } else {
          listOfVariants.push({
            idx: variant.idx,
            group: variant.group?.title || "",
            order: variant.order,
            conf_group_idx: "",
            conf_groups: variant.conf_groups,
            conf_groups_title: variant.conf_groups_title,
            title: variant.title,
          });
        }
      }
    }
  }

  listOfVariants.sort((a: any, b: any) => (a.order < b.order ? -1 : 1));

  return listOfVariants;
});

const variantsListPrio = computed(() => {
  let listOfVariants: {
    idx: string;
    prio: number;
    group: string;
    conf_group_idx: string;
    conf_groups: object;
    title: string;
  }[] = [];

  if (props.item && props.item.variants) {
    for (let variantIdx in props.item.variants) {
      const variant = props.item.variants[variantIdx];
      if (!variant) continue;
      if (variant.prio !== -1) {
        listOfVariants.push({
          idx: variant.idx,
          prio: variant.prio,
          group: variant.group?.title || "",
          conf_group_idx: "",
          conf_groups: variant.conf_groups,
          title: variant.title,
        });
      }
    }
  }

  listOfVariants.sort((a: any, b: any) => (a.prio < b.prio ? -1 : 1));

  return listOfVariants;
});

const variants = computed(() => {
  let variants: any = {};

  if (props.item && props.item.variants) {
    for (let variantIdx in props.item.variants) {
      const variant = props.item.variants[variantIdx];
      if (variant) {
        variants[variant.idx] = variant;
      }
    }
  }

  return variants;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "variant-list",
      tag: "ul",
      class: "block space-y-4 w-screen px-4 md:w-full"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsListPrio.value, (menuVariant) => {
          return (_openBlock(), _createElementBlock("li", {
            key: menuVariant.idx,
            class: "font-bold text-sm block border-b border-gray-100"
          }, [
            _createVNode(ItemV2VariantsList, {
              variant: menuVariant,
              "variant-data": variants.value[menuVariant.idx],
              "item-facts": __props.item.facts,
              "show-values": true,
              onPatch: _cache[0] || (_cache[0] = (event) => _ctx.$emit('patch', event))
            }, null, 8, ["variant", "variant-data", "item-facts"])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, {
      name: "variant-list",
      tag: "ul",
      class: "block space-y-4 w-screen px-4 md:w-full mt-4"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (menuVariant) => {
          return (_openBlock(), _createElementBlock("li", {
            key: menuVariant.idx,
            class: "font-bold text-base block border-b border-gray-100 pb-4"
          }, [
            _createVNode(ItemV2VariantsList, {
              variant: menuVariant,
              "variant-data": variants.value[menuVariant.idx],
              "item-facts": __props.item.facts,
              onPatch: _cache[1] || (_cache[1] = (event) => _ctx.$emit('patch', event))
            }, null, 8, ["variant", "variant-data", "item-facts"])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})